<template>
<div class="pa-5">
  <strong class="text-h3 grey--text">{{ $t('construction') }}</strong>
</div>
</template>

<script>
export default {
name: "Requests"
}
</script>

<style scoped>

</style>
